export function getTagHeight(size) {
    switch (size) {
        case "sm":
            return "1.75rem";
        case "md":
            return "2rem";
        case "lg":
        default:
            return "2.5rem";
    }
}
//# sourceMappingURL=helper.js.map